import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DictionaryState } from '../store/dictionary/dictionary.reducer';
import { Observable } from 'rxjs';
import { IDictionary } from '@interfaces';
import { LanguageService } from './language.service';
@Injectable({
  providedIn: 'root',
})
export class FilterTextService {
  dictionary$: Observable<any>;
  dictionary: IDictionary[] = [];
  constructor(
    private _store: Store<{ dictionary: DictionaryState }>,
    private languageService: LanguageService,
  ) {
    this.dictionary$ = this._store.select((state) => state.dictionary.dictionary);
    this.dictionary$.subscribe((data) => (this.dictionary = data));
  }
  getFilterText(status: string) {
    if (status.trim() === '') return '';
    const currentLang = this.languageService.getCurrentLang();
    const key = currentLang === 'he' ? 'hebrew' : 'arabic';
    const [filterData] = this.dictionary.filter((ele) => ele[key] === status || ele.english === status);
    return filterData?.english || status;
  }
}
